import { Button, Form, Grid, Input } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LogsUserFilterFormField, LogsUserFilterFormValues } from './logs-types';


const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
    formId: string;
    handleFilter: (values: LogsUserFilterFormValues) => void;
    initialValues: LogsUserFilterFormValues;
    closeModal?: () => void;
};

export const LogsUsersFilterForm = ({
    formId,
    handleFilter,
    initialValues,
    closeModal,
}: UsersFilterFormProps) => {
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<LogsUserFilterFormValues>();
    const { t } = useTranslation();
    const screens = useBreakpoint();

    const onReset = () => {
        form.resetFields();
        handleFilter(initialValues);
    };

    const onFinish = (formValues: LogsUserFilterFormValues) => {
        handleFilter(formValues);
        closeModal?.();
    };

    return (
        <Form<LogsUserFilterFormValues>
            id={formId}
            name={formId}
            className='filters-form'
            form={form}
            layout='vertical'
            onFinish={onFinish}
            initialValues={initialValues}
            onFinishFailed={() => {
                setValidateTrigger(['onChange']);
            }}
            validateTrigger={validateTrigger}
        >
            <ContentFilters.FormItemsWrapper className='cf_frm' style={{ width: '100%' }}>
                <StandardItemsWrapper className='cf_frm_row' style={{ width: '100%' }}>
                    <div className='invoice_list' style={{ width: '100%' }}>

                        <Form.Item<LogsUserFilterFormValues>
                            label={'Name'}
                            name={LogsUserFilterFormField.Name}
                        >
                            <Input
                                placeholder={t('adminUsers.formFields.userName.placeholder')}
                            />
                        </Form.Item>
                        <Form.Item<LogsUserFilterFormValues>
                            label={'Phone'}
                            name={LogsUserFilterFormField.PhoneNumber}
                        >
                            <Input
                                placeholder={t('adminUsers.formFields.phoneNumber.placeholder')}
                            />
                        </Form.Item>
                        <Form.Item<LogsUserFilterFormValues>
                            label={'Email'}
                            name={LogsUserFilterFormField.Email}
                        >
                            <Input placeholder={t('adminUsers.formFields.email.placeholder')} />
                        </Form.Item>
                        {screens.lg && (
                            <ContentFilters.ButtonsWrapper className='filter_btn'>
                                <Button type='primary' htmlType='submit'>
                                    {t('common.buttons.filter', { count: 1 })}
                                </Button>
                                <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
                            </ContentFilters.ButtonsWrapper>
                        )}
                    </div>
                </StandardItemsWrapper>
            </ContentFilters.FormItemsWrapper>


        </Form>
    );
};
